export const DESTINATIONS_CONFIG = [
  {
    key: "athens",
    image: "/assets/v2/images/athens-greece-pexels-pixabay-164336.jpg",
  },
  {
    key: "brisbane",
    image:
      "/assets/v2/images/brisbane-local-marketing-wo-9xGVnVYA-unsplash.jpg",
  },
  {
    key: "edinburgh",
    image: "/assets/v2/images/edinburgh-uk-jim-divine-qpQ7NQ2CXA4-unsplash.jpg",
  },
  {
    key: "lisbon",
    image:
      "/assets/v2/images/lisbon-portugal-andre-lergier-anrBiSm4iFQ-unsplash.jpg",
  },
  {
    key: "london",
    image:
      "/assets/v2/images/london-uk-big-ben-westminster-bridge-sunset-london-uk.jpg",
  },
  {
    key: "losAngeles",
    image:
      "/assets/v2/images/los-angeles-us-jake-blucker-8LlJNFLTEm0-unsplash.jpg",
  },
  {
    key: "madrid",
    image:
      "/assets/v2/images/madrid-spain-florian-wehde-WBGjg0DsO_g-unsplash.jpg",
  },
  {
    key: "osaka",
    image: "/assets/v2/images/osaka-romeo-a-lRk99Hn1bMQ-unsplash.jpg",
  },
  {
    key: "porto",
    image:
      "/assets/v2/images/porto-portugal-svetlana-gumerova-L_CLVBXkaiI-unsplash.jpg",
  },
  {
    key: "santorini",
    image:
      "/assets/v2/images/santorini-greece-pexels-axp-photography-500641970-16563668.jpg",
  },
  {
    key: "singapore",
    image: "/assets/v2/images/singapore-hu-chen-5O6c_pLziXs-unsplash.jpg",
  },
] as const;
